module.exports = __webpack_public_path__ + "static/media/reviewArrow.5fd0042b.svg";